import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../../../Shared/colors";
import { DataGrid } from "@mui/x-data-grid";
// import StarBorderIcon from '@mui/icons-material/StarBorder';
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useGetTelesalesTodoListQuery } from "../../../../features/telesaletaskSlice";
import { Toaster, toast } from "react-hot-toast";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useAddtelesaleLeadTaskMutation } from "../../../../features/telesaletaskSlice";
import Tooltip from "@mui/material/Tooltip";
import moment from 'moment-timezone';
import { createPortal } from "react-dom";
import { UnifiedTaskTable } from "../Telesalesearchleads/UnifiedTaskTable";

export const TodoListDataTable = ({ filters = {} }) => {
  const [popUp, setpopUp] = useState(false);
  const [loading, setloading] = useState(false);
  const [leadNumber, setLeadNumber] = useState("");
  const [leadId, setleadId] = useState("");

  const [addTask, { isLoading }] = useAddtelesaleLeadTaskMutation();
  const [taskPopUp, setTaskPopUp] = useState(false);
  const [maxDate, setmaxDate] = useState("");

  const [minDate, setminDate] = useState("");

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.keyCode === 27) {
        setpopUp(false);
        setTaskPopUp(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  // const today = new Date();
  // const numberOfDaysToAdd = 0;
  // const date = today.setDate(today.getDate() + numberOfDaysToAdd);
  // const defaultDate = new Date(date).toISOString().split("T")[0];

  const today = moment();
  const defaultDate = today.format('YYYY-MM-DDTHH:mm');
  const newMinDate = today.clone().subtract(1, 'days').format('YYYY-MM-DDTHH:mm');

  useEffect(() => {
    setminDate(newMinDate);
  }, [newMinDate]);

  useEffect(() => {
    setmaxDate(defaultDate);
  }, [defaultDate]);
  const [task, settask] = useState({
    currentTaskType: "",
    currentSubTypeTask: "",
    completedDate: defaultDate,
    reason: "",
    comment: "",
    nextTaskType: "",
    deadline: "",
    attachment: "",

  });

  let handleChange = (e) => {
    const { name, value } = e.target;

      settask((prevTask) => ({
        ...prevTask,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    settask((prevstate) => ({
      ...prevstate,
      [name]: e.target.files[0],
    }));
    e.target.value = '';
  };

  const handleType = (e) => {
    handleChange(e);
  };

  const handleSubtype = (e) => {
    handleChange(e);
  };


  const handleSave = () => {
    // Prevent multiple submissions
    if (isLoading) {
      return;
    }

    // Frontend validations
    if (!task.currentTaskType) {
      return toast.error("Please select current task type");
    }
    if (!task.currentSubTypeTask) {
      return toast.error("Please select current sub type");
    }
    if (!task.nextTaskType) {
      return toast.error("Please select next task");
    }
    if (task.currentTaskType.toLowerCase() === 'call' && task.currentSubTypeTask.toLowerCase() === 'whatsapp' && !task.attachment) {
      return toast.error("Whatsapp proof image is required");
    }

    // Check if we need to send FormData (when there's a file attachment)
    const isWhatsapp = task.currentTaskType.toLowerCase() === 'call' && task.currentSubTypeTask.toLowerCase() === 'whatsapp';

    let requestPromise;

    if (isWhatsapp && task.attachment) {
      // Use FormData for file upload
      const formData = new FormData();
      formData.append('assignmentID', task.assignmentID);
      formData.append('leadID', task.leadId);
      formData.append('telesalesEmployeeID', task.telesalesEmployeeID);
      formData.append('originalEmployeeID', task.originalEmployeeID);
      formData.append('currentTaskType', task.currentTaskType);
      formData.append('currentSubTypeTask', task.currentSubTypeTask);
      formData.append('comment', task.comment);
      formData.append('nextTaskType', task.nextTaskType);
      formData.append('deadline', task.deadline);
      formData.append('attachment', task.attachment);

      requestPromise = addTask(formData);
    } else {
      // Use regular JSON payload for non-file uploads
      const payload = {
        assignmentID: task.assignmentID,
        leadID: task.leadId,
        telesalesEmployeeID: task.telesalesEmployeeID,
        originalEmployeeID: task.originalEmployeeID,
        currentTaskType: task.currentTaskType || "",
        currentSubTypeTask: task.currentSubTypeTask || "",
        comment: task.comment || "",
        nextTask: {
          nextTaskType: task.nextTaskType || "",
          deadline: task.deadline || ""
        },
      };

      requestPromise = addTask(payload);
    }

    requestPromise
      .unwrap()
      .then((res) => {
        toast.success("task created successfully");
        settask({
          currentTaskType: "",
          currentSubTypeTask: "",
          completedDate: defaultDate,
          reason: "",
          assignmentID: "",
          comment: "",
          nextTaskType: "",
          deadline: "",
          attachment: "",
          leadId: task.leadId,
        });
        setpopUp(false);
      })
      .catch((error) => {
        toast.error(error?.data?.error?.message || "Something went wrong");
      });
  };

  useEffect(() => {
    if (taskPopUp || popUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [taskPopUp, popUp]);


  const [pageSize, setPageSize] = useState(50);

  const [todoType, settodoType] = useState("today");

  const { data: todolistData, isFetching, error, refetch } = useGetTelesalesTodoListQuery(todoType, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true
  });

  const columns = [
    {
      field: "task",
      headerName: "Task",
      width: 150,
    },
    {
        field: "deadline",
      headerName: "Deadline",
        width: 150,
        renderCell: (params) => {
          return (
            <div>
              {params.row.deadline ? (
              <div style={{
                color: '#666',
                fontSize: '0.9rem'
              }}>
                {params.row.deadline.toDateString()}
              </div>
            ) : (
              <span style={{ color: '#999', fontStyle: 'italic' }}>
                No Deadline
              </span>
              )}
            </div>
          );
        },
      },
    {
      field: "client",
      headerName: "Client Name",
      width: 150,
      renderCell: (params) => {
        return (
          <Client>
            <Tooltip title={params.row.client || 'No client name available'}>
              <div style={{
                fontWeight: '600',
                color: '#333',
                fontSize: '0.9rem'
              }}>
                {params.row.client || 'N/A'}
              </div>
            </Tooltip>
          </Client>
        );
      },
    },
    // {
    //   field: "rating",
    //   headerName: "Rating",
    //   width: 150,
    // },
    {
      field: "phone",
      headerName: "Phone Number",
      width: 150,
      renderCell: (params) => {
        const phoneNo = params.row.phone;
        return phoneNo ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span style={{ fontSize: '0.9rem' }}>📞</span>
            <a
              href={`tel:+${phoneNo}`}
              style={{
                color: '#249393',
                textDecoration: 'none',
                fontWeight: '500',
                fontSize: '0.9rem'
              }}
              onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
              onMouseOut={(e) => e.target.style.textDecoration = 'none'}
            >
            {phoneNo}
          </a>
          </div>
        ) : (
          <span style={{ color: '#999', fontStyle: 'italic', fontSize: '0.9rem' }}>
            No phone
          </span>
        );
      },
    },
    // {
    //   field:'allocatedto',
    //   headerName:'Allocated To',
    //   width:130,
    //   renderCell:(params)=>{
    //     return(
    //       <Allocated>
    //         <div>
    //           {params.row.allocatedto}
    //         </div>
    //         {/* <div>
    //           faisalabad
    //         </div> */}
    //       </Allocated>
    //     )
    //   }
    // },
    {
      field: "classification",
      headerName: "Lead ID",
      width: 120,
      renderCell: (params) => {
        return (
          <Id>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              flexDirection: 'column'
            }}>
              <div style={{
                color: '#249393',
                fontWeight: '700',
                fontSize: '0.9rem'
              }}>
                {params.row.leadID || 'N/A'}
            </div>
              <div style={{ fontSize: '0.8rem', color: '#666' }}>
                {params.row.classification === "veryHot" ? (
                  <DeviceThermostatIcon sx={{ color: colors.veryHot, fontSize: '16px' }} />
        ) : params.row.classification === "hot" ? (
                  <DeviceThermostatIcon sx={{ color: colors.hot, fontSize: '16px' }} />
        ) : params.row.classification === "moderate" ? (
                  <DeviceThermostatIcon sx={{ color: colors.moderate, fontSize: '16px' }} />
        ) : params.row.classification === "cold" ? (
                  <DeviceThermostatIcon sx={{ color: colors.cold, fontSize: '16px' }} />
                ) : (
                  <DeviceThermostatIcon sx={{ color: colors.veryCold, fontSize: '16px' }} />
                )}
              </div>
            </div>
          </Id>
        );
      },
    },
    {
      field: "project",
      headerName: "Project",
      width: 110,
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.project}>
            <div style={{ color: `${colors.textBlue}` }}>
              {params.row.project}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "action",
      headerName: "Actions",
      width: 180,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => {
        let whatsappLink = `https://wa.me/` + params.row.cellNo;
        return (
          <Action>
            <div
              onClick={() => {
                settask({
                  ...task,
                  taskId: params.row.id,
                  clientId: params.row.clientId,
                  clientname: params.row.client,
                  phoneNo: params.row.cellNo,
                  projectName: params.row.project,
                  DProjectID: params.row.projectID,
                  leadStatus: params.row.leadstatus,
                  telesalesEmployeeID: params.row.telesalesEmployeeID,
                  telesalesEmployeeName: params.row.telesalesEmployeeName,
                  originalEmployeeID: params.row.originalEmployeeID,
                  originalEmployeeName: params.row.originalEmployeeName,
                  leadId: params.row.telesaleleadid,
                  assignmentID: params.row.assignmentID,
                });
                setpopUp(true);
              }}
            >
              <img src="/assets/icons/plus.png" alt="plus" />
            </div>
            <a
              href={whatsappLink}
              onClick="location.href=this.href+'?key='+number;return false;"
              target="_blank"
              rel="noreferrer"
            >
              <WhatsAppIcon style={{ color: "green", cursor: "pointer" }} />
            </a>
            <RemoveRedEyeIcon
              style={{ color: `${colors.brown}`, cursor: "pointer" }}
              onClick={() => {
                setTaskPopUp(true);
                setleadId(params.row.telesaleleadid);
                setLeadNumber(params.row.leadID)
              }}
            />
          </Action>
        );
      },
    },
  ];

  let rows = [];
  
  todolistData?.forEach((todo, index) => {
    
    const rowData = {
      id: todo._id,
      assignmentID: todo?.assignmentID,  // Add assignmentID for task creation
      task: todo?.nextTask?.nextTaskType,
      deadline: todo?.nextTask?.deadline
        ? new Date(todo?.nextTask?.deadline)
        : null,
      client: todo?.leadID?.clientID?.fullName || 'N/A',
      clientId: todo?.leadID?.clientID?._id,
      rating: todo?.leadID?.clientID?.clientRating,
      project: todo?.leadID?.leadOpportunity?.project?.projectName,
      projectID: todo?.leadID?.leadOpportunity?.project?._id,
      classification: todo?.leadID?.leadOpportunity?.classification,
      cellNo: todo?.leadID?.clientID?.cellNo?.[0]?.phoneNo || 'N/A',
      mail: todo?.leadID?.clientID?.email || 'N/A',
      phone: todo?.leadID?.clientID?.cellNo?.[0]?.phoneNo || 'N/A',
      leadID: todo?.leadID?.leadID || 'N/A',
      leadstatus: todo?.leadID?.leadStatus,
      telesalesEmployeeID: todo?.telesalesEmployeeID?._id,
      telesalesEmployeeName: `${todo?.telesalesEmployeeID?.firstName || ""} ${todo?.telesalesEmployeeID?.lastName || ""}`.trim(),
      originalEmployeeID: todo?.originalEmployeeID?._id,
      telesaleleadid: todo?.leadID?._id,
      originalEmployeeName: `${todo?.originalEmployeeID?.firstName || ""} ${todo?.originalEmployeeID?.lastName || ""}`.trim(),
    };
    
    // Apply filters
    let shouldInclude = true;
    
    // Task filter - exact match with backend values
    if (filters.task) {
      const nextTaskType = todo?.nextTask?.nextTaskType;
      
      // Check if the selected task type matches the nextTaskType
      const isMatch = nextTaskType === filters.task;
      
      if (!isMatch) {
        shouldInclude = false;
      }
    }
    
    if (filters.project && rowData.projectID !== filters.project) {
      shouldInclude = false;
    }
    
    // Phone number filter - use partial matching
    if (filters.phoneNumber) {
      const phoneStr = rowData.phone ? rowData.phone.toString() : '';
      const searchPhone = filters.phoneNumber.toString();
      if (!phoneStr.includes(searchPhone)) {
        shouldInclude = false;
      }
    }
    
    // Lead ID filter - use partial matching for better UX
    if (filters.leadID) {
      const leadIDStr = rowData.leadID ? rowData.leadID.toString() : '';
      const searchLeadID = filters.leadID.toString();
      if (!leadIDStr.includes(searchLeadID)) {
        shouldInclude = false;
      }
    }
    
    if (filters.classification && rowData.classification !== filters.classification) {
      shouldInclude = false;
    }
    
    if (shouldInclude) {
      rows.push(rowData);
    }
  });

  return (
    <Main>
      <TimeSection>
        <button
          style={{
            backgroundColor:
              todoType === "overdue" ? `${colors.brown}` : `${colors.white}`,
            color:
              todoType === "overdue" ? `${colors.white}` : `${colors.black}`,
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
          }}
          onClick={() => settodoType("overdue")}
        >
          Overdue
        </button>
        <button
          style={{
            backgroundColor:
              todoType === "today" ? `${colors.brown}` : `${colors.white}`,
            color: todoType === "today" ? `${colors.white}` : `${colors.black}`,
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
          }}
          onClick={() => settodoType("today")}
        >
          Today
        </button>
        <button
          style={{
            backgroundColor:
              todoType === "tomorrow" ? `${colors.brown}` : `${colors.white}`,
            color:
              todoType === "tomorrow" ? `${colors.white}` : `${colors.black}`,
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
          }}
          onClick={() => settodoType("tomorrow")}
        >
          Tomorrow
        </button>
        <button
          style={{
            backgroundColor:
              todoType === "7 days" ? `${colors.brown}` : `${colors.white}`,
            color:
              todoType === "7 days" ? `${colors.white}` : `${colors.black}`,
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
          }}
          onClick={() => settodoType("7 days")}
        >
          7 Days
        </button>
        <button
          style={{
            backgroundColor:
              todoType === "next month" ? `${colors.brown}` : `${colors.white}`,
            color:
              todoType === "next month" ? `${colors.white}` : `${colors.black}`,
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
          }}
          onClick={() => settodoType("next month")}
        >
          Next Month
        </button>
        {/* <button
          style={{
            backgroundColor:
              todoType === "Do Nothing" ? `${colors.brown}` : `${colors.white}`,
            color:
              todoType === "Do Nothing" ? `${colors.white}` : `${colors.black}`,
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
          }}
          onClick={() => settodoType("Do Nothing")}
        >
          Do Nothing
        </button> */}
      </TimeSection>
      <LeadsSection>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span>📋</span>
          <span>Todo List:</span>
          <span style={{
            color: '#249393',
            fontWeight: '700',
            fontSize: '1.2rem',
            background: 'linear-gradient(135deg, #249393, #1a6b6b)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            {todolistData?.length || 0}
          </span>
          <span style={{ fontSize: '0.9rem', color: '#666', marginLeft: '0.5rem' }}>
            ({todoType} tasks)
          </span>
        </div>
      </LeadsSection>
      <Table>
        {error ? (
          <div style={{ padding: '2rem', textAlign: 'center', color: 'red' }}>
            Error loading tasks: {error?.data?.message || error?.message || 'Unknown error'}
          </div>
        ) : rows.length === 0 && !isFetching ? (
          <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
            No tasks found for {todoType}
          </div>
        ) : isFetching ? (
          <div style={{
            padding: '2rem',
            textAlign: 'center',
            color: '#666',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem'
          }}>
            <div style={{
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #249393',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }} />
            <span>Loading {todoType} tasks...</span>
          </div>
        ) : (
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            checkboxSelection
            disableSelectionOnClick
            loading={isFetching}
            autoHeight
            sx={{
              border: "none",
            }}
          />
        )}
      </Table>
      {popUp && createPortal(
        <PortalPopUpContainer>
        <PopUp>
          <Cross
            onClick={() => {
              settask({
                currentTaskType: "",
                currentSubTypeTask: "",
                completedDate: defaultDate,
                subType: "",
                reason: "",
                comment: "",
                nextTaskType: "",
                deadline: "",
                attachment: "",
                leadId: task.leadId,
              });
              setpopUp(false);
            }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          <PopUpSection>
            <Section>
              <Task>
                  <Heading>Current Task</Heading>
                <InputPart>
                  <InputFeild>
                      <h3>
                        Type:<b style={{ color: "red" }}>*</b>
                      </h3>
                    <div>
                      <select
                        name="currentTaskType"
                        id="currentTaskType"
                        value={task.currentTaskType}
                        onChange={handleType}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                          <option value="call">Call</option>
                      </select>
                    </div>
                  </InputFeild>
                  <InputFeild>
                    <h3>Sub-Type:<b style={{ color: "red" }}>*</b></h3>
                    <div>
                        {/* <select
                        name="currentSubTypeTask"
                        id="currentSubTypeTask"
                        value={task.currentSubTypeTask}
                        onChange={handleSubtype}
                      >
                                     <option value=""  >Select</option>
                        {subType?.map((ls) => (
                          <option value={ls} key={ls}>
                            {ls}
                          </option>
                        ))}
                                   </select> */}
                        <select
                          name="currentSubTypeTask"
                          id="currentSubTypeTask"
                          value={task.currentSubTypeTask || ""}
                          onChange={handleSubtype}
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          <option value="Call connected">Call Connected</option>
                          <option value="Call Not Connected">Call Not Connected</option>
                          <option value="followUp">Follow Up</option>
                          <option value="follow_up_sent">Follow Up Sent</option>
                          <option value="sms">SMS</option>
                          <option value="whatsapp">Whatsapp</option>
                          <option value="meeting_completed">Meeting Completed</option>
                      </select>

                    </div>
                  </InputFeild>
                  <InputFeild>
                    <h3>Completed Date:<b style={{ color: "red" }}>*</b></h3>
                    <div>
                      <input
                        type="datetime-local"
                        name="completedDate"
                        id="completedDate"
                        value={task.completedDate || defaultDate}
                        onChange={handleChange}
                        min={newMinDate}
                        max={defaultDate}
                      />
                    </div>
                  </InputFeild>
                      <InputFeild>
                        <h3>Comment:<b style={{ color: "red" }}>*</b></h3>
                        <textarea
                          name="comment"
                          id="comment"
                          placeholder="type here..."
                          value={task.comment}
                          onChange={handleChange}
                        ></textarea>
                      </InputFeild>
                      {
                      task.currentTaskType === 'call' && task.currentSubTypeTask === "whatsapp" ?
                          <InputFeild>
                          <h3>Attachment (Picture Proof):<b style={{ color: "red" }}>*</b></h3>
                            <span>
                            <p>Upload WhatsApp screenshot/proof</p>
                              <label htmlFor="attachment">
                                <AttachFileIcon /> Upload
                              </label>
                              {task.attachment && (
                                <UploadedFile
                                  src={URL.createObjectURL(task.attachment)}
                                  alt="uploaded file"
                                />
                              )}
                            </span>
                            <input
                              type="file"
                              name="attachment"
                              id="attachment"
                            accept="image/*"
                              onChange={handleFileChange}
                            />
                          </InputFeild> : null}

                  </InputPart>
                </Task>
              </Section>
              <Section>
                <Task style={{ borderRight: "none" }}>
                  <Heading>Next Task</Heading>
                  <InputPart>
                        <InputFeild>
                      <h3>Next Task:<b style={{ color: "red" }}>*</b></h3>
                          <div>
                            <select
                          name="nextTaskType"
                          id="nextTaskType"
                          value={task.nextTaskType || ""}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                          <option value="meeting_schedule">Meeting Scheduled</option>
                          <option value="followUp">Follow Up</option>
                          <option value="meeting_reschedule">Reschedule Meeting</option>
                        </select>
                          </div>
                        </InputFeild>

                      <InputFeild>
                      <h3>Deadline:<b style={{ color: "red" }}>*</b></h3>
                        <div>
                        <input
                          type="datetime-local"
                          name="deadline"
                          id="deadline"
                          value={task.deadline}
                          onChange={handleChange}
                          min={new Date().toISOString().slice(0, 16)}
                          />
                        </div>
                        </InputFeild>
                </InputPart>
              </Task>
              </Section>
            </PopUpSection>
              <ButtonPart>
                <button
                className="cancel-btn"
                  onClick={() => {
                    settask({
                      currentTaskType: "",
                      currentSubTypeTask: "",
                      completedDate: defaultDate,
                      subType: "",
                      reason: "",
                      comment: "",
                      nextTaskType: "",
                      deadline: "",
                      leadId: task.leadId,
                    });
                    setpopUp(false);
                  }}
                >
                  Cancel
                </button>
                <button
                className="save-btn"
                  style={{
                    opacity: isLoading ? "0.5" : "1",
                  }}
                  onClick={handleSave}
                  disabled={isLoading}
                >
                  {isLoading ? <>Saving...</> : <>Save</>}
                </button>
              </ButtonPart>
        </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}

      {taskPopUp && createPortal(
        <PortalPopUpContainer>
        <PopUp>
            <Crosstask
            onClick={() => setTaskPopUp(!taskPopUp)}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
            </Crosstask>
            <PopUpSection className="task-table-section" style={{ height: "calc(100% - 80px)" }}>
              <UnifiedTaskTable leadID={leadId} leadNumber={leadNumber} />
          </PopUpSection>
        </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}
      <Toaster />
    </Main>
  );
};

const Main = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: ${colors.white};
  border-radius: 24px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  position: relative;
  min-height: 80vh;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    z-index: 1;
  }
`;
const TimeSection = styled.div`
  padding: 1rem 2rem 0;
  border-bottom: 1px solid ${colors.inputBorderWhite};
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  
  button {
    padding: 0.75rem 1.5rem;
    min-width: 120px;
    border: none;
    background-color: ${colors.lightWhite};
    color: ${colors.text};
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 8px 8px 0 0;
    font-size: 0.875rem;
    font-weight: 500;
    position: relative;
    
    &:hover {
      background-color: ${colors.brown};
      color: ${colors.white};
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(36, 147, 147, 0.3);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
`;

const LeadsSection = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  padding: 1rem 2rem;
  margin: 0;
  color: ${colors.text};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 1px solid ${colors.inputBorderWhite};
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
  
  span {
    font-weight: 700;
    color: ${colors.brown};
    background: linear-gradient(135deg, ${colors.brown}, ${colors.textBlue});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Table = styled.div`
  padding: 1.5rem 2.5rem 2.5rem 2.5rem;
  
  .MuiDataGrid-root {
    border: none !important;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    background: ${colors.white};
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    }
  }
  
  .MuiDataGrid-main {
    border-radius: 16px;
  }
  
  .MuiDataGrid-columnHeaders {
    background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
    border-bottom: 3px solid ${colors.inputBorderWhite};
    font-weight: 700;
    color: ${colors.text};
    min-height: 60px !important;
    
    .MuiDataGrid-columnHeaderTitle {
      font-weight: 700;
      font-size: 0.9rem;
      letter-spacing: 0.025em;
    }
  }
  
  .MuiDataGrid-columnHeader {
    font-size: 0.9rem;
    font-weight: 700;
    color: ${colors.text};
    padding: 0 16px;
  }
  
  .MuiDataGrid-row {
    border-bottom: 1px solid ${colors.inputBorderWhite};
    transition: all 0.2s ease;
    
    &:hover {
      background: linear-gradient(135deg, ${colors.lightWhite} 0%, rgba(36, 147, 147, 0.05) 100%) !important;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
    
    &.Mui-selected {
      background: linear-gradient(135deg, rgba(36, 147, 147, 0.1) 0%, rgba(36, 147, 147, 0.05) 100%) !important;
      border-left: 4px solid ${colors.brown};
    }
    
    &:nth-of-type(even) {
      background: rgba(248, 249, 250, 0.5);
    }
  }
  
  .MuiDataGrid-cell {
    border: none !important;
    font-size: 0.85rem;
    color: ${colors.text};
    padding: 16px;
    display: flex;
    align-items: center;
    
    &:focus {
      outline: none;
    }
  }
  
  .MuiDataGrid-footerContainer {
    border-top: 2px solid ${colors.inputBorderWhite};
    background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
    min-height: 70px;
    padding: 0 24px;
  }
  
  .MuiTablePagination-root {
    color: ${colors.textMed};
    font-weight: 500;
    
    .MuiTablePagination-selectLabel,
    .MuiTablePagination-displayedRows {
      font-weight: 600;
      color: ${colors.text};
    }
    
    .MuiTablePagination-select {
      border-radius: 8px;
      border: 1px solid ${colors.inputBorderWhite};
      padding: 4px 8px;
      
      &:hover {
        border-color: ${colors.brown};
      }
    }
  }
  
  .MuiCheckbox-root {
    color: ${colors.brown} !important;
    padding: 8px;
    
    &.Mui-checked {
      color: ${colors.brown} !important;
    }
    
    &:hover {
      background: rgba(36, 147, 147, 0.1);
      border-radius: 4px;
    }
  }
  
  // Custom scrollbar
  .MuiDataGrid-virtualScroller {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: ${colors.lightWhite};
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: ${colors.inputBorderWhite};
      border-radius: 4px;
      
      &:hover {
        background: ${colors.textMed};
      }
    }
  }
  
  @media (max-width: 768px) {
    padding: 1rem 2rem 2rem 2rem;
    
    .MuiDataGrid-columnHeaders {
      min-height: 50px !important;
      
      .MuiDataGrid-columnHeaderTitle {
        font-size: 0.8rem;
      }
    }
    
    .MuiDataGrid-columnHeader {
      font-size: 0.8rem;
      padding: 0 12px;
    }
    
    .MuiDataGrid-cell {
      font-size: 0.8rem;
      padding: 12px;
    }
    
    .MuiDataGrid-footerContainer {
      min-height: 60px;
      padding: 0 16px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem 1rem 1rem 1rem;
    
    .MuiDataGrid-columnHeaders {
      min-height: 45px !important;
      
      .MuiDataGrid-columnHeaderTitle {
        font-size: 0.75rem;
      }
    }
    
    .MuiDataGrid-columnHeader {
      font-size: 0.75rem;
      padding: 0 8px;
    }
    
    .MuiDataGrid-cell {
      font-size: 0.75rem;
      padding: 8px;
    }
    
    .MuiDataGrid-footerContainer {
      min-height: 50px;
      padding: 0 12px;
    }
  }
`;

const Client = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
  }
`;

const Id = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  div {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: ${colors.textBlue};
  }
  p {
    color: ${colors.textMed};
  }
`;

const Action = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  gap: 0.75rem;
  padding: 8px;
  
  div {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    background: linear-gradient(135deg, ${colors.white} 0%, ${colors.lightWhite} 100%);
    border: 1px solid ${colors.inputBorderWhite};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    
    &:hover {
      background: linear-gradient(135deg, ${colors.lightWhite} 0%, rgba(36, 147, 147, 0.1) 100%);
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      border-color: ${colors.brown};
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
    
    img {
      width: 18px;
      height: 18px;
      object-fit: contain;
      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    }
  }
  
  .MuiSvgIcon-root {
    transition: all 0.3s ease;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    
    &:hover {
      transform: scale(1.1);
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    }
  }
  
  // WhatsApp icon special styling
  .MuiSvgIcon-root[style*="green"] {
    &:hover {
      color: #25d366 !important;
      transform: scale(1.15);
      filter: drop-shadow(0 2px 8px rgba(37, 211, 102, 0.3));
    }
  }
  
  // Eye icon special styling
  .MuiSvgIcon-root[style*="brown"] {
    &:hover {
      color: ${colors.brown} !important;
      transform: scale(1.15);
      filter: drop-shadow(0 2px 8px rgba(36, 147, 147, 0.3));
    }
  }
`;

const PopUpContainer = styled.div`
  background-color: #0000004d;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: ${(props) => (props.popUp ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  isolation: isolate;
`;
const PopUp = styled.div`
  width: 95vw;
  max-width: 1200px;
  height: 85vh;
  max-height: 800px;
  overflow: hidden;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    border-radius: 16px 16px 0 0;
  }
  
  /* Allow tooltips to appear above modal */
  .MuiDataGrid-root {
    z-index: 1 !important;
  }
  
  .MuiDataGrid-columnHeaders {
    z-index: 2 !important;
  }
  
  .MuiDataGrid-menuIcon {
    z-index: 3 !important;
  }
  
  .MuiDataGrid-columnHeaderTitle {
    z-index: 2 !important;
  }
  
  /* Ensure tooltips appear above modal */
  .MuiTooltip-popper {
    z-index: 9999 !important;
  }
`;
const PortalPopUpContainer = styled.div`
  background-color: #0000004d;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 1000 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  isolation: isolate !important;
  pointer-events: auto !important;
`;

const Cross = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff4757;
  border-radius: 50%;
    cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
    
    &:hover {
    background: #ff3742;
    box-shadow: 0 6px 16px rgba(255, 71, 87, 0.4);
    }
  
  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;

const PopUpSection = styled.div`
  width: 100%;
  background-color: ${colors.white};
  display: flex;
  justify-content: space-between;
  flex: 1;
  overflow-y: auto;
  padding: 0;
  
  &.task-table-section {
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
  }
`;

const Section = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  border-right: 1px solid #e0e0e0;
  height: 100%;
  
  &:last-child {
    border-right: none;
  }
`;

const Task = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 1.5rem;
`;
const Crosstask = styled.div`
  position: absolute;
  top: 10px;
  right: 2px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff4757;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
  
  &:hover {
    background: #ff3742;
    box-shadow: 0 6px 16px rgba(255, 71, 87, 0.4);
  }
  
  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;
const Heading = styled.div`
  width: 100%;
  text-align: left;
  padding: 0 0 1rem 0;
  color: ${colors.textBlue};
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 1.5rem;
`;

const InputPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;
  
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    color: ${colors.text};
    margin: 0 0 0.5rem 0;
  }
`;

const InputFeild = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  h3 {
    color: ${colors.text};
    font-size: 0.95rem;
    font-weight: 500;
    margin: 0;
  }
  p {
    color: ${colors.veryHot};
    margin-top: 0.5em;
  }
  div {
    position: relative;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    width: 100%;
    background-color: #f8f9fa;
    
    &:focus-within {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }

    select,
    input[type="date"] {
      background-color: transparent;
      width: 100%;
      padding: 12px 16px;
      outline: none;
      border: none;
      font-size: 0.95rem;
      color: ${colors.text};
      
      ::placeholder {
        color: #999;
      }
    }
  }
  input,
  textarea {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #f8f9fa;
    width: 100%;
    padding: 12px 16px;
    outline: none;
    font-size: 0.95rem;
    color: ${colors.text};
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    ::placeholder {
      color: #999;
    }
  }
  span {
    background-color: ${colors.inputWhite};
    padding: 1em 0em 1em 1em;
    border-radius: 5px;
    border: 1px solid ${colors.inputBorderWhite};
    display: flex;
    position: relative;
    label {
      position: absolute;
      right: 3%;
      top: 20%;
      background-color: ${colors.black};
      color: ${colors.white};
      padding: 0.5em 1em;
      border-radius: 5px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p {
      font-size: clamp(1em, 1vh, 2em);
      color: ${colors.textMed};
    }
  }
  input[type="file"] {
    display: none;
  }
`;

const ButtonPart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
  gap: 1rem;
  
  .cancel-btn {
    background: #6c757d;
    color: ${colors.white};
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    min-width: 120px;
    outline: none;
    flex: 1;
    max-width: 200px;
      
      &:hover {
      background: #5a6268;
      box-shadow: 0 8px 20px rgba(108, 117, 125, 0.3);
    }
    
    &:active {
    }
  }
  
  .save-btn {
    background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
      color: ${colors.white};
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    min-width: 120px;
    outline: none;
    flex: 1;
    max-width: 200px;
      
      &:hover {
      box-shadow: 0 8px 20px rgba(36, 147, 147, 0.3);
    }
    
    &:active {
    }
  }
`;

const FixedContainer = styled.div`
  width: 100%;
  min-height: 3em;
  margin-top: 1em;
  background-color: ${colors.inputBorderWhite};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 1em;
`;

const Price = styled.div`
  display: flex;
  p {
    margin-left: 2em;
  }
  margin-top: 1em;
`;

const TaskLoader = styled.div`
  margin-top: 1em;
`;
const BankInputFeild = styled.div`
  width: 100%;
  h3 {
    color: ${colors.black};
    font-size: clamp(1em, 1vw, 2em);
    margin: 1em 0em;
  }
`;

const UploadedFile = styled.img`
  border-radius: 50%;
  margin-left: 50%;
  width: 70px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;
